export type StoryMembershipLevel = 0 | 1 | 2;

export const STORY_STORAGE_LIMITS: Record<StoryMembershipLevel, number> = {
  0: 3,
  1: 20,
  2: Number.POSITIVE_INFINITY
};

export function normalizeStoryMembershipLevel(value: unknown): StoryMembershipLevel {
  const level = Number(value);
  return level === 1 || level === 2 ? level : 0;
}

export function getStoryStorageLimit(level: unknown) {
  return STORY_STORAGE_LIMITS[normalizeStoryMembershipLevel(level)];
}
